import { getAlarmById, populateAlarmContent } from "../reducers/helpers/status_reducer";
import moment from "moment";
import { flatten } from "lodash";

export const isBitfield = item => (getAlarmById(item.id) || item).type === 'bitfield';
const replaceAt = (string, index, value) =>
  `${string.substring(0, index)}${value}${string.substring(index + value.length)}`;

const resetIndex = (i, bits, decode) => {
  const result = !decode[i] ? replaceAt(bits, bits.length - i - 1, '0') : bits;

  return i < bits.length ?
    resetIndex(i + 1, result, decode) :
    result;
};

// Remove 211 endpoint's heartbeat
export const getBits = item => resetIndex(
  0,
  item.value.toString(2),
  getAlarmById(item.id).decode
);

export function formatResults(results) {
  const reworked = [];

  results.forEach(items => {
    const reworkedItems = [];

    items
      .forEach((item) => {

        if (isBitfield(item)) {
          item.bits = getBits(item);
        }

        const previousItem = reworkedItems[reworkedItems.length - 1];

        if (!reworkedItems.length ||
          (previousItem.bits && previousItem.bits !== item.bits) ||
          (!previousItem.bits && previousItem.value !== item.value)) {

          // Convert Alarm and event ID to Human readable strings
          const readable = populateAlarmContent(item);
          Object.assign(item, readable);

          item.displayTimestamp = moment(item.timestamp).format(
            "DD/MM/YYYY, HH:mm"
          );

          reworkedItems.push(item);
        }
      });

    reworked.push(reworkedItems);
  });

  return flatten(reworked);
}


// WEBPACK FOOTER //
// ./src/helpers/getStatus.js